import { logUsage } from 'owa-analytics';

export function logDiscoverMenuOpened() {
    logUsage('FluidDiscoverMenuOpened', {}, { isCore: true });
}

export function logDiscoverMenuPreloadFailed() {
    logUsage('DiscoverManifestPreloadFailed', {}, { isCore: true });
}
